// @ts-nocheck
import {Column} from 'react-table'
import {RolePermissionInfoCell} from './RolePermissionInfoCell'
import {RolePermissionLastLoginCell} from './RolePermissionLastLoginCell'
import {RolePermissionTwoStepsCell} from './RolePermissionTwoStepsCell'
import {RolePermissionActionsCell} from './RolePermissionActionsCell'
import {RolePermissionSelectionCell} from './RolePermissionSelectionCell'
import {RolePermissionCustomHeader} from './RolePermissionCustomHeader'
import {RolePermissionSelectionHeader} from './RolePermissionSelectionHeader'
import {RolePermission} from '../../core/_models'
import { FormattedMessage } from 'react-intl'

const rolespermissionsColumns: ReadonlyArray<Column<RolePermission>> = [
  {
    Header: (props) => <RolePermissionSelectionHeader tableProps={props} />,
    id: 'selection',
    Cell: ({...props}) => <RolePermissionSelectionCell id={props.data[props.row.index].id} />,
  },
  {
    Header: (props) => <RolePermissionCustomHeader tableProps={props} title={<FormattedMessage id='ROLE.TABLE.COLUMN.NAME' defaultMessage={"نام نقش"} />} className='min-w-125px' />,
    id: 'name',
    accessor: 'name',
  },
  {
    Header: (props) => <RolePermissionCustomHeader tableProps={props} title={<FormattedMessage id='ROLE.TABLE.COLUMN.CREATEDDATE' defaultMessage={"تاریخ ایجاد"} />} className='min-w-125px' />,
    id: 'created_at',
    accessor: 'created_at',
    Cell: ({value}) => new Date(value).toLocaleDateString(), // Format date
  },
  {
    Header: (props) => (
      <RolePermissionCustomHeader tableProps={props} title={<FormattedMessage id='TABLE.GENERAL.ACTION' defaultMessage={"عملیات"} />} className='text-end min-w-100px' />
    ),
    id: 'actions',
    Cell: ({...props}) => <RolePermissionActionsCell id={props.data[props.row.index].id} />,
  },
]

export {rolespermissionsColumns}
